export const polygonOptions = {
  strokeColor: "#F00",
  strokeOpacity: 0.9,
  strokeWeight: 2,
  fillColor: "#F00",
  fillOpacity: 0.5
}